import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ScanRunsListItem } from "../../../types";

const ScanRunsTableNoteCell = ({
  item: scanRun,
  ...cellProps
}: TableSimpleCellProps<ScanRunsListItem>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={scanRun.note} drawerTitle="Note" />
    </TableSimpleCell>
  );
};

export default ScanRunsTableNoteCell;
